export class SupplierUserModel {
  createdBy?: number;
  createdOn?: Date;
  email?: string;
  id: number;
  isDeleted: boolean;
  isFirstLogin: boolean;
  name?: string;
  password?: string;
  phone?: string;
  photo?: string;
  position?: string;
  supplierId?: number;
  supplierUserStatusId: number;
  updatedBy?: number;
  updatedOn?: Date;
  photo64Base?: string;
  mimeType?: string;
  company: string;

  constructor() {
  }
}

